import {RouteConfig} from "vue-router";

const manageFeeRoutes: Array<RouteConfig> = [
    {
        path: "manage-fee",
        component: () => import("./index.vue"),
        name: "debtCustomer",
        meta: { title: "Quản lý cước phí" }
    }
];

export default manageFeeRoutes;
